import { Skeleton } from '@chakra-ui/react'
import './style.css'

type PropsCardMetrics = {
    value: number
    label: string
    isLoading?: boolean
}

export function CardMetrics({
    value,
    label,
    isLoading = false
}: PropsCardMetrics) {
    if (isLoading) {
        return (
            <div className="card">
                <div></div>
                <Skeleton height="24px" width="40%" className="number" />
                <Skeleton height="24px" width="80%" className="label" />
            </div>
        )
    }

    return (
        <div className="card">
            <div></div>
            <div className="number">{value}</div>
            <div className="label">{label}</div>
        </div>
    )
}
